import service from "@/utils/service.js"
import { showLoadingToast, addApiPathFor } from "./Utils.js"

// 心跳测试接口
export const apiTest = () => {
  return service({
    url: addApiPathFor("/heartbeat"),
    method: "get"
  })
}

// 登录接口
export const login = data => {
  // showLoadingToast()
  return service({
    url: addApiPathFor("/app/login"),
    method: "post",
    data
  })
}

///////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
// Okta登录接口 - 获取登录页面
export const loginOkta = () => {
  // showLoadingToast()
  return service({
    url: addApiPathFor("/auth/oktaLogin"),
    method: "post"
  })
}

// Okta登录成功后回调接口
export const callbackOkta = data => {
  // showLoadingToast()
  return service({
    url: addApiPathFor("/auth/oktaCallback"),
    method: "post",
    data
  })
}

// 注册
export const register = data => {
  return service({
    url: addApiPathFor("/register"),
    method: "post",
    data
  })
}

export const logout = data => {
  return service({
    url: "/api/auth/logout",
    method: "post",
    data,
    loading: 0
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js